import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    BohemiaOptions,
} from 'owa-outlook-service-options';

export enum FluidEnabledScenario {
    MailReadingPane,
    MailCompose,
    CalendarCompose,
}

export function isFluidEnabledForScenario(scenario: FluidEnabledScenario): boolean {
    // Bohemia was the old name for Fluid. BohemiaOptions is a server enum so it is not being renamed
    if (getOptionsForFeature<BohemiaOptions>(OwsOptionsFeatureType.Bohemia).bohemiaEnabled) {
        switch (scenario) {
            case FluidEnabledScenario.MailReadingPane:
                return isFeatureEnabled('rp-prague');
            case FluidEnabledScenario.MailCompose:
                return isFeatureEnabled('cmp-prague');
            case FluidEnabledScenario.CalendarCompose:
                return isFeatureEnabled('cal-cmp-fluid');
        }
    }
    return false;
}
